import { ModelHooks } from "services/strapi"
import { documentApi } from "../services/document.strapi.api"
import { IDocument } from "../types/document.types"

class DocumentHooks extends ModelHooks<IDocument> {}

export const documentHooks = new DocumentHooks(documentApi)
